import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DiscountsModalComponent } from './discounts-modal.component';
import { DiningPlansTableComponent } from './dining-plans/table/table.component';
import { DiningPlansComponent } from './dining-plans/dining-plans.component';
import { DiningPlanComponent } from './dining-plans/plan/plan.component';
import { BreadcrumbModule } from '@finder/shared/components/breadcrumb/breadcrumb.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { SectionModule } from '@finder/shared/components/section/section.module';

@NgModule({
    imports: [
        CommonModule,
        BreadcrumbModule,
        FontIconModule,
        SectionModule
    ],
    declarations: [
        DiscountsModalComponent,
        DiningPlansTableComponent,
        DiningPlansComponent,
        DiningPlanComponent,
    ],
    providers: [],
    exports: [
        DiscountsModalComponent,
        DiningPlansTableComponent,
        DiningPlansComponent,
        DiningPlanComponent,
    ]
})
export class DiscountsModalModule {
    static entry = DiscountsModalComponent;
}
